import { Link } from "react-router-dom";
import styled from "styled-components";

export const InputFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 15px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 60% 35%;
  }
`;

export const InputsLeft = styled.div`
  display: grid;
  grid-template-columns: 10% 87%;
  grid-gap: 3%px;
  justify-content: center;
  align-items: center;
`;
export const InputsRight = styled.div`
  display: grid;
  grid-template-columns: 12% 85%;
  grid-gap: 3%;
  justify-content: center;
  align-items: center;
`;

export const InputsSearchFilter = styled.div`
  grid-gap: 3%;
  justify-content: center;
  align-items: center;
`;

export const Input = styled.input`
  padding: 5px 12px;
  width: 100%;
  height: 35px;

  &:focus {
    border: 1px solid hsl(0, 0%, 80%);
    border-radius: 5px;
    outline: none;
  }
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  width: 100%;
  grid-gap: 1rem;
  margin-top: 3rem;
`;

export const Solicitud = styled(Link)`
  display: grid;
  grid-template-columns: 80% 20%;
  border: 1px solid #dce6e6;
  height: 120px;
  border-radius: 15px;
  padding: 0.5rem 1rem;

  &:hover {
    background-color: #f5faff;
  }
`;

export const SolicitudInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Id = styled.p`
  font-size: 13px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const Title = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: darkslategray;

  @media (max-width: 768px) {
    font-size: 13px;
    font-weight: 600;
  }
`;

export const Photo = styled.div`
  border-radius: 50%;
  background-color: ${(props) => props.bg && "#3c6ebe"};
  color: white;
  align-self: center;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;

  @media (min-width: 1024px) {
    width: 42px;
    height: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 60%;
  }

  @media (max-width: 640px) {
    width: 100%;
    height: 60%;
  }
`;

export const Body = styled.div`
  font-size: 14px;
  display: flex;
`;

export const Span = styled.span`
  font-weight: bold;
  color: #3c6ebe;
`;

export const Tecnico = styled.div`
  display: grid;
  grid-template-columns: 8.5% 91.5%;

  @media (max-width: 640px) {
    grid-template-columns: 20% 80%;
  }
`;

export const Etiqueta = styled.span`
  padding: 2px 6px;
  border-radius: 5px;
  color: #6450d2;
  border: 1px solid #6450d2;
  font-size: 14px;
`;
